import { Component, OnInit } from "@angular/core";
import { ItemModel } from "../model/itemModel";
import { ItemService } from "../service/item.service";
import { OrderService } from "../service/order.service";

@Component({
  selector: "app-add-item",
  templateUrl: "./add-item.component.html",
  styleUrls: ["./add-item.component.css"],
})
export class AddItemComponent implements OnInit {
  item: ItemModel = {
    Id: null,
    ItemName: "",
    ItemDesc: "",
    ItemId: "",
    ItemsIncluded: "",
    OrderNumber: "",
    LineNumber: null,
    SupplierName: "",
    PurchaseDate: new Date(),
    WarrantyDate: new Date(),
    Destination: "",
    ItemOwnerName: "",
    ItemOwnerPhone: "",
    Notes: "",
    ReportBy: "",
    ReportDate: null,
    ReceivedDate: null,
    OrderId: null,
  };

  message: string = "";
  isSuccess: boolean = false;

  itemsList: any[] = [];

  orderDetails: any;

  constructor(
    private itemService: ItemService,
    private orderService: OrderService
  ) {}

  ngOnInit() {
    this.itemService.getItemList().subscribe(
      (response: string[]) => {
        console.log(response);

        // Convert string array into PrimeNG dropdown format
        this.itemsList = response.map((itemName) => ({
          label: itemName,
          value: itemName,
        }));
      },
      (error) => {}
    );
  }

  onSubmit(form: any) {
    console.log("Form Submitted", form.value);
    console.log("Item Data:", this.item);

    this.itemService.addItem(this.item).subscribe(
      (response) => {
        console.log(response);
        if (response) {
          this.message = "הפריט הוסף בהצלחה";
          this.isSuccess = true;
          form.reset();

          this.item.PurchaseDate = new Date();
          this.item.WarrantyDate = new Date();
        } else {
          this.message = "התרחשה שגיאה בהוספת הפריט";
          this.isSuccess = false;
        }
      },
      (error) => {
        console.error("Error:", error);
        this.message = "התרחשה שגיאה במערכת";
        this.isSuccess = false;
      }
    );
  }

  getOrderDetails = (orderNumber: string) => {
    let orderFilter = {
      OrderNumber: orderNumber,
    };

    this.orderService.getCustomerOrders(orderFilter).subscribe(
      (response) => {
        this.orderDetails = response;

        console.log("orderDetails:", this.orderDetails);

        if (this.orderDetails.length === 0) {
          // If the response is empty, show a message
          this.message = "הזמנה לא נימצאה";
          this.isSuccess = false; // Optional: You can use this to style the message (success or error)

          this.resetItem();
        } else {
          this.message = "";
          // If the order is found, populate the fields
          this.item.SupplierName = this.orderDetails[0].SupplierName;
          // Convert string date to Date object
          this.item.PurchaseDate = new Date(this.orderDetails[0].CreateDate);
          this.item.Destination = this.orderDetails[0].Destination;
          this.item.ItemOwnerName = this.orderDetails[0].DestinationName;

          this.item.ItemName = this.orderDetails[0].ItemName;
        }
      },
      (error) => {
        console.log(error);
        this.message = "אירעה שגיאה בעת חיפוש ההזמנה"; // Error message
        this.isSuccess = false;
      }
    );
  };

  resetItem() {
    this.item = {
      Id: null,
      ItemName: "",
      ItemDesc: "",
      ItemId: "",
      ItemsIncluded: "",
      OrderNumber: "",
      LineNumber: null,
      SupplierName: "",
      PurchaseDate: new Date(),
      WarrantyDate: new Date(),
      Destination: "",
      ItemOwnerName: "",
      ItemOwnerPhone: "",
      Notes: "",
      ReportBy: "",
      ReportDate: null,
      ReceivedDate: null,
      OrderId: null,
    };
  }
}



// WEBPACK FOOTER //
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/app/add-item/add-item.component.ts